export class Pattern {
    static validar(e: any, patron: any) {
        const tecla = e.keyCode || e.which;

        if (tecla === 8 || tecla === 9) {
            return true;
        }

        const tecla_final = String.fromCharCode(tecla);
        if (patron.test(tecla_final))
            return true;
        else
            e.preventDefault();
    }

    static onlyNumber(e: any) {
        const patron = /[0-9]/;
        return this.validar(e, patron);
    }

    static onlyDecimal(e: any) {
        const patron = /[0-9.,]/;
        return this.validar(e, patron);
    }

    static onlyLetter(e: any) {
        e.target.value = e.target.value.toUpperCase();
        const patron = /^[A-Za-z_\-.\s\xF1\xD1]+$/;
        return this.validar(e, patron);
    }

    static onlyAlpha(e: any) {
        e.target.value = e.target.value.toUpperCase();
        const patron = /^[0-9A-Za-z.,_\-.\s\xF1\xD1]+$/;
        return this.validar(e, patron);
    }

    static toUpper(e: any){
       e.target.value = e.target.value.toUpperCase();
    }
}